import React from "react";
import { CircularProgress, Typography } from '@material-ui/core';
import { red, grey } from "@material-ui/core/colors";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";



function AlarmeCP ({ label, status }) {
    if (status === undefined) { return null; }
    if (!status) { return null; }

    const tipo = status? {variant: 'indeterminate'} : { variant: 'static', value: 100 }
    const cor = status? {

    } : {}

    return (
        <Grid style={{flex: 0.15}}>
            <Paper variant="outlined" style={{margin:'5px', backgroundColor: 'red'}}>
                <CircularProgress size={20} color={status? 'secondary' : 'primary' } {...tipo} />
                <Typography note>{label}</Typography>
            </Paper>
        </Grid>
    )
}


export default (AlarmeCP)
